import { IAuthState } from "src/modules/Auth/store/types";
import { match } from "react-router";
import * as moment from 'moment'
import { IResponseCases } from "src/share/types/case/searchCase";
import { History, Location } from 'history';
import * as _ from 'lodash'
export const sortOptions = {
    missingSince: "Date",
    fullName: 'Name',
    country: 'Country',
    type: 'Case Type',
    agency: 'Agency',
    state: 'State',
    city: 'City'
}
export enum FetchType {
    Initial,
    Infinite,
    Filter,
    Sort,
    History
}
export interface ICasesViewState {
    sort: any[],
    sortName: string,
    search: string,
    page: number,
    size: number,
    data: IResponseCases;
    loading: boolean;
    fetchingData: boolean;
    range: {
        startDate: moment.Moment | null;
        endDate: moment.Moment | null;
        focus: "startDate" | "endDate" | null;
    }
    createdDateRange: {
        startDate: moment.Moment | null;
        endDate?: moment.Moment | null;
    }
    showDatePicker: boolean;
};

export interface ICasesViewProps {
    auth: IAuthState;
    history: History;
    location: Location;
    match: match<{ viewType?: string; }>;
};
export const initialResults: IResponseCases = {
    cases: {
        total: 0,
        results: []
    }
}

export const initialStateCaseView: ICasesViewState = {
    sort: [{ "missingSince": "desc" }, "fullName"],
    sortName: 'missingSince',
    search: '',
    page: 0,
    size: 10,
    data: _.cloneDeep(initialResults),
    loading: true,
    fetchingData: false,
    range: {
        startDate: null,
        endDate: null,
        focus: null
    },
    createdDateRange: {
        startDate: null
    },
    showDatePicker: false
}




// WEBPACK FOOTER //
// ./src/modules/Case/View/caseView.type.ts